import { React, useEffect, useState } from "react";
import axios from "axios";
import { BillingTable, CompanyCreate } from "..";
import SearchIcon from "@mui/icons-material/Search";
import MuiAlert from "@mui/material/Alert"; // Import MuiAlert for Snackbar
import { Dialog, DialogTitle, Snackbar } from "@mui/material";

function BillingSearch() {
  const [companyName, setCompanyName] = useState("");
  const [companies, setCompanies] = useState([]);
  const [updateTable, setUpdateTable] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(""); // For custom Snackbar messages

  useEffect(() => {
    showBillingSearchResults();
  }, [companyName, updateTable]);

  const showBillingSearchResults = () => {
    const body = new FormData();
    body.append("companyName", companyName);
    axios.post("/company/searchCompanies", body).then((res) => {
      if (res.data.success) {
        setCompanies(res.data.companies);
      }
    });
  };

  const resetHooks = () => {
    setCompanyName("");
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <>
      <div className="BillingSearch bg-brand-tertiary h-full">
        <div className="BillingSearch-container flex flex-col p-8 h-full">
          <div className="BillingSearch-topContainer flex flex-wrap">
            <div className="BillingSearch-searchBar flex search-button h-11 mr-4 w-60 mb-4">
              <input
                type="text"
                className="font-brand-quaternary h-full rounded-full ml-4 w-full"
                placeholder="Search"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
              <div className="my-auto mx-2">
                <SearchIcon size={16} />
              </div>
            </div>

            <button
              type="button"
              className="BillingSearch-resetButton search-button px-4 h-11 mb-4 text-center py-2"
              onClick={resetHooks}>
              Reset Search
            </button>
          </div>
          <div className="BillingSearch-bottomContainer flex w-full h-full">
            <BillingTable
              companies={companies}
              updateTable={updateTable}
              setUpdateTable={setUpdateTable}
              setOpenSnackbar={setOpenSnackbar}
              setSnackbarMessage={setSnackbarMessage}
            />
          </div>
        </div>
      </div>
      {/* Snackbar for success/error messages */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }} // Bottom left position
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={snackbarMessage.includes("Failed") ? "error" : "success"}
          onClose={handleCloseSnackbar}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default BillingSearch;
